export enum CommonAccountsApiEndpoints {
  CreateExternalAccount = '/accounts/CreateAndAttachExternalAccount',
  CreateUnlistedAccount = '/accounts/CreateAndAttachUnlistedAccount',
  DetachAccount = '/accounts/DetachAccount',
  GetAccountInstitutions = '/institutions/GetInstitutions?IncludeBrokers=true',
}
